import type { DocumentAssociationsInput } from "generated-graphql/graphql";
import type { DocumentFormData } from "../types";

export function getAssociations(
  data: DocumentFormData,
  tenantId: string,
  reportId: string | undefined,
  facilityId: string | undefined
): DocumentAssociationsInput[] {
  return [
    ...(data.facilities ?? []).map((facility) => ({
      tenantId: tenantId ?? "",
      facilityId: facility.id,
    })),
    ...(data.activityId || reportId
      ? [
          {
            tenantId: tenantId ?? "",
            facilityId: facilityId ?? "",
            reportId,
            activityId: data.activityId,
          },
        ]
      : []),
  ];
}
